import * as React from 'react';
import { IconMetroMsk16, IconMetroSpb16 } from '@cian/ui-kit';

interface IUndergroundIconProps {
  regionId: number;
}

export function UndergroundIcon(props: IUndergroundIconProps) {
  const { regionId } = props;

  switch (regionId) {
    case -2:
    case 2:
    case 4588:
      return <IconMetroSpb16 color={'current_color'} />;
    case -1:
    case 1:
    case 4593:
    default:
      return <IconMetroMsk16 color={'current_color'} />;
  }
}
